// extracted by mini-css-extract-plugin
export default {"status":"ListStatus_status__KPMfK","spinner":"ListStatus_spinner__2bXj4","spin":"ListStatus_spin__1I8qU","message":"ListStatus_message__ht7qb","error":"ListStatus_error__P2G3K"};